// extracted by mini-css-extract-plugin
module.exports = {"tooltip":"AvatarWithTooltip_tooltip__3kMsU","hoverable":"AvatarWithTooltip_hoverable__AhvJi"};